import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { getTimeFromNow } from '../../../../../core/utils/date-fns-utils';
import { selectColumnNotes } from '../../state/location-list-selectors';
import { getFullNameForFieldID } from '../../../location-utils';
import { MatMenuTrigger, MatMenu, MatMenuContent } from '@angular/material/menu';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { LocationListApiService } from '../../location-list-api.service';
import { ExtractAndWrapLinksPipe } from '../../../../../pipes/extract-and-wrap-links.pipe';
import { NgClass } from '@angular/common';
import { MatDivider } from '@angular/material/divider';
import { GtagEventDirective } from '../../../../../core/gx-gtag/gtag-event.directive';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-row-menu-header',
    templateUrl: './row-menu-header.component.html',
    styleUrls: ['./row-menu-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [LetDirective, MatIconButton, MatTooltip, MatIcon, GtagEventDirective, MatDivider, NgClass, MatMenuTrigger, MatMenu, MatMenuContent, ExtractAndWrapLinksPipe]
})
export class RowMenuHeaderComponent implements IHeaderAngularComp {
  @ViewChild('menuTrigger') trigger: MatMenuTrigger;

  columnNotesInfoOpened: boolean = false;
  columnNotes$ = this.store.select(selectColumnNotes);

  constructor(private store: Store, private locationListApi: LocationListApiService) {
  }

  /**
   * The method is called on the header component once.
   * @param params
   */
  agInit(params: IHeaderParams): void {};

  /**
   * Gets called when a new Column Definition has been set for this header.
   * If you handle the refresh of your header return true otherwise return false
   * and the grid will re-create your header from scratch.
   * @param params
   */
  refresh(params: IHeaderParams): boolean {
    return true;
  };

  /**
   * HTML wrapper
   * @param date
   */
  getTimeFromNow(date: number) {
    return getTimeFromNow(new Date(date));
  }

  /**
   * Returns a prettified column name based on its ID.
   * @param columnName
   */
  getPrettyFieldName(columnName: string) {
    return getFullNameForFieldID(columnName);
  }

  /**
   * Resets column state to the value provided initially by column definitions.
   * @param e
   */
  resetTableLayout(e: Event) {
    e.stopPropagation()
    this.locationListApi.gridApi.resetColumnState();
  }

  /**
   * Adjust width of visible columns to fit available horizontal space (without overflow)
   * @param e
   */
  sizeColumnsToFit(e: Event) {
    e.stopPropagation();
    this.locationListApi.gridApi.sizeColumnsToFit();
  }

}
